(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function() {
    function isInWishlist(productId) {
      try {
        const wishlist = JSON.parse(localStorage.getItem('vtl_wl') || '[]');
        return wishlist.some(item => String(item.id) === String(productId) || String(item.product_id) === String(productId));
      } catch (e) {
        return false;
      }
    }

    function updateButtonState(btn) {
      const productId = btn.dataset.productId;
      if (isInWishlist(productId)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Quitar de favoritos');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Añadir a favoritos');
      }
    }

    function toggleWishlist(btn) {
      const productId = btn.dataset.productId;
      const variantId = btn.dataset.variantId;
      const productHandle = btn.dataset.productHandle;
      const inWishlist = isInWishlist(productId);

      if (window.Vitals && window.Vitals.Wishlist) {
        if (inWishlist) {
          window.Vitals.Wishlist.remove(productId);
        } else {
          window.Vitals.Wishlist.add(productId, variantId);
        }
        setTimeout(() => updateButtonState(btn), 100);
        return;
      }

      try {
        let wishlist = JSON.parse(localStorage.getItem('vtl_wl') || '[]');

        if (inWishlist) {
          wishlist = wishlist.filter(item => String(item.id) !== String(productId) && String(item.product_id) !== String(productId));
        } else {
          wishlist.push({
            id: productId,
            product_id: productId,
            variant_id: variantId,
            handle: productHandle,
            added_at: Date.now()
          });
        }

        localStorage.setItem('vtl_wl', JSON.stringify(wishlist));
        updateButtonState(btn);
        window.dispatchEvent(new CustomEvent('vtl:wishlist:updated'));
      } catch (e) {
        console.error('Wishlist error:', e);
      }
    }

    function initCartWishlistButtons() {
      const buttons = document.querySelectorAll('.cart-items__wishlist-btn');
      buttons.forEach(btn => {
        updateButtonState(btn);
        // Evitar agregar múltiples listeners
        if (!btn.dataset.wishlistInit) {
          btn.dataset.wishlistInit = 'true';
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleWishlist(this);
          });
        }
      });
    }

    // Init on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartWishlistButtons);
    } else {
      initCartWishlistButtons();
    }

    // Re-init after cart updates (for morphing)
    document.addEventListener('cart:update', () => {
      setTimeout(initCartWishlistButtons, 200);
    });

    // Listen for wishlist updates from other sources
    window.addEventListener('vtl:wishlist:updated', () => {
      document.querySelectorAll('.cart-items__wishlist-btn').forEach(updateButtonState);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function() {
    // Tab switching functionality
    function initCartDrawerTabs() {
      const tabs = document.querySelectorAll('.cart-drawer__tab');
      const panels = document.querySelectorAll('.cart-drawer__panel');

      tabs.forEach(tab => {
        if (tab.dataset.tabInit) return;
        tab.dataset.tabInit = 'true';

        tab.addEventListener('click', function() {
          const targetPanel = this.dataset.tab;

          // Update tabs
          tabs.forEach(t => {
            t.classList.toggle('cart-drawer__tab--active', t.dataset.tab === targetPanel);
            t.setAttribute('aria-pressed', t.dataset.tab === targetPanel ? 'true' : 'false');
          });

          // Update panels
          panels.forEach(p => {
            p.classList.toggle('cart-drawer__panel--active', p.dataset.panel === targetPanel);
          });

          // Load wishlist if switching to wishlist tab
          if (targetPanel === 'wishlist') {
            loadWishlistItems();
          }
        });
      });
    }

    // Load wishlist items
    async function loadWishlistItems() {
      const container = document.getElementById('cart-drawer-wishlist');
      if (!container) return;

      // Get wishlist from localStorage
      let wishlist = [];
      try {
        wishlist = JSON.parse(localStorage.getItem('vtl_wl') || '[]');
      } catch (e) {
        wishlist = [];
      }

      if (wishlist.length === 0) {
        container.innerHTML = '<div class="cart-drawer__wishlist-empty">No tienes productos en favoritos</div>';
        return;
      }

      container.innerHTML = '<div class="cart-drawer__wishlist-loading">Cargando favoritos...</div>';

      // Get product handles from wishlist
      const handles = wishlist
        .map(item => item.handle)
        .filter(h => h);

      if (handles.length === 0) {
        // Try to load by product ID if no handles
        container.innerHTML = '<div class="cart-drawer__wishlist-empty">No se pudieron cargar los favoritos</div>';
        return;
      }

      // Fetch product data
      const products = [];
      for (const handle of handles.slice(0, 10)) { // Limit to 10 items
        try {
          const response = await fetch(`/products/${handle}.json`);
          if (response.ok) {
            const data = await response.json();
            products.push(data.product);
          }
        } catch (e) {
          console.error('Error loading wishlist product:', e);
        }
      }

      if (products.length === 0) {
        container.innerHTML = '<div class="cart-drawer__wishlist-empty">No se pudieron cargar los favoritos</div>';
        return;
      }

      // Render products
      container.innerHTML = products.map(product => {
        const variant = product.variants[0];
        const price = formatMoney(variant.price);
        const imageUrl = product.image ? product.image.src.replace(/\.([^.]+)$/, '_300x.$1') : '';
        const hasMultipleVariants = product.variants.length > 1;

        return `
          <div class="cart-drawer__wishlist-item" data-product-id="${product.id}" data-handle="${product.handle}">
            <a href="/products/${product.handle}" class="cart-drawer__wishlist-item__image">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
            </a>
            <div class="cart-drawer__wishlist-item__info">
              <a href="/products/${product.handle}" class="cart-drawer__wishlist-item__title">${product.title}</a>
              <div class="cart-drawer__wishlist-item__price">${price}</div>
            </div>
            <div class="cart-drawer__wishlist-item__actions">
              <button
                type="button"
                class="cart-drawer__wishlist-item__add"
                data-variant-id="${variant.id}"
                data-product-url="/products/${product.handle}"
                data-has-variants="${hasMultipleVariants}"
              >
                ${hasMultipleVariants ? 'Elegir' : 'Añadir'}
              </button>
              <button
                type="button"
                class="cart-drawer__wishlist-item__remove"
                data-product-id="${product.id}"
                data-handle="${product.handle}"
                aria-label="Quitar de favoritos"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </button>
            </div>
          </div>
        `;
      }).join('');

      // Add event listeners for add buttons
      container.querySelectorAll('.cart-drawer__wishlist-item__add').forEach(btn => {
        btn.addEventListener('click', async function() {
          const hasVariants = this.dataset.hasVariants === 'true';
          const productUrl = this.dataset.productUrl;

          if (hasVariants) {
            // Open quick-add modal for variant selection
            openQuickAddModal(productUrl);
            return;
          }

          const variantId = this.dataset.variantId;
          const originalText = this.textContent;
          this.textContent = 'Añadiendo...';
          this.disabled = true;

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: parseInt(variantId),
                quantity: 1
              })
            });

            if (response.ok) {
              this.textContent = '¡Añadido!';
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 1500);
            } else {
              throw new Error('Add failed');
            }
          } catch (e) {
            this.textContent = 'Error';
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);
          }
        });
      });

      // Add event listeners for remove buttons
      container.querySelectorAll('.cart-drawer__wishlist-item__remove').forEach(btn => {
        btn.addEventListener('click', function() {
          const productId = this.dataset.productId;
          const item = this.closest('.cart-drawer__wishlist-item');

          // Remove from localStorage
          try {
            let wishlist = JSON.parse(localStorage.getItem('vtl_wl') || '[]');
            wishlist = wishlist.filter(item =>
              String(item.id) !== String(productId) &&
              String(item.product_id) !== String(productId)
            );
            localStorage.setItem('vtl_wl', JSON.stringify(wishlist));

            // Remove from UI with animation
            item.style.opacity = '0';
            item.style.transform = 'translateX(20px)';
            item.style.transition = 'all 0.3s ease';

            setTimeout(() => {
              item.remove();
              // Check if empty
              const remaining = container.querySelectorAll('.cart-drawer__wishlist-item');
              if (remaining.length === 0) {
                container.innerHTML = '<div class="cart-drawer__wishlist-empty">No tienes productos en favoritos</div>';
              }
            }, 300);

            // Dispatch event
            window.dispatchEvent(new CustomEvent('vtl:wishlist:updated'));
          } catch (e) {
            console.error('Error removing from wishlist:', e);
          }
        });
      });
    }

    function formatMoney(price) {
      // El API de productos de Shopify devuelve el precio como string con decimales (ej: "89000.00")
      // Lo convertimos a número y formateamos
      const numPrice = parseFloat(price) || 0;
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
      }).format(numPrice);
    }

    // Open quick-add modal for products with multiple variants
    async function openQuickAddModal(productUrl) {
      const dialogComponent = document.getElementById('quick-add-dialog');
      if (!dialogComponent) {
        // Fallback: navigate to product page
        window.location.href = productUrl;
        return;
      }

      try {
        // Fetch product page content
        const response = await fetch(productUrl);
        if (!response.ok) {
          window.location.href = productUrl;
          return;
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const productGrid = doc.querySelector('[data-product-grid-content]');

        if (!productGrid) {
          window.location.href = productUrl;
          return;
        }

        const modalContent = document.getElementById('quick-add-modal-content');
        if (!modalContent) {
          window.location.href = productUrl;
          return;
        }

        // Clear and add new content
        modalContent.innerHTML = productGrid.innerHTML;

        // Re-initialize any custom elements in the modal
        const scripts = productGrid.querySelectorAll('script');
        scripts.forEach(script => {
          const newScript = document.createElement('script');
          newScript.textContent = script.textContent;
          modalContent.appendChild(newScript);
        });

        // Open the dialog
        const dialog = dialogComponent.querySelector('dialog');
        if (dialog) {
          dialog.showModal();
        }

      } catch (e) {
        console.error('Error opening quick add modal:', e);
        window.location.href = productUrl;
      }
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawerTabs);
    } else {
      initCartDrawerTabs();
    }

    // Re-initialize after cart updates (for morphing)
    document.addEventListener('cart:update', () => {
      setTimeout(initCartDrawerTabs, 200);
    });

    // Re-initialize when dialog opens
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (mutation.target.hasAttribute('open')) {
            setTimeout(initCartDrawerTabs, 100);
          }
        }
      }
    });

    // Start observing cart drawer dialog
    function observeCartDialog() {
      const dialog = document.querySelector('.cart-drawer__dialog');
      if (dialog) {
        observer.observe(dialog, { attributes: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCartDialog);
    } else {
      observeCartDialog();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
